// notify.js is a UMD module (Notify.js - http://notifyjs.com/).
//
// Dev mode:  Vite serves the file as-is. The UMD IIFE hits the browser
//            globals branch and calls factory(jQuery), attaching $.notify.
// Prod mode: Rollup detects the CommonJS branch (typeof module === 'object')
//            and wraps the module. factory(jQuery) is NOT called, so $.notify
//            is missing. We detect this and call the exported factory manually.
//
// NOTE: vite.config.ts の build.commonjsOptions.include に notify.js を
//       追加し、Rollup が CJS 分岐を検出できるようにしている。
import * as notifyModule from './src/notify';

if (window.jQuery && typeof window.jQuery.notify !== 'function') {
  const factory = notifyModule.default;
  if (typeof factory === 'function') {
    factory(window, window.jQuery);
  }
}
